<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="h-100">
        <h4 v-html="block.text"></h4>
        <div v-if="!!block.text2" v-html="block.text2"></div>
        <b-form-group>
          <b-form-radio-group
            :size="size"
            v-model="answer"
            :stacked="!inline"
            :state="!!error ? false : null"
            @change="error = null"
            :disabled="!!answer"
          >
            <b-form-radio
              v-for="(o, index) in options"
              :key="index"
              :value="o.value"
              :state="o.value == answer ? (answer == correctAnswer) : null"
            >
              {{ o.value }}
              <div v-if="o.description" v-html="o.description"></div>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-alert variant="success" :show="!!answer && answer === correctAnswer" class="text-center">
          <i class="fa fa-fw fa-check"></i>
          {{ trans('you_have_correct_answer') }}
          <div v-if="!!correctAnswerDescription" v-html="correctAnswerDescription" class="mt-1">
          </div>
        </b-alert>
        <b-alert variant="danger" :show="!!answer && answer !== correctAnswer" class="text-center">
          <i class="fa fa-fw fa-times"></i>
          {{ trans('you_have_wrong_answer') }}
        </b-alert>
        <p v-if="!!answer" class="text-center">
          <b-button variant="light" :size="size" class="border"  @click="onClear">
            <i class="fa fa-fw fa-redo"></i>
            {{ trans('try_again') }}
          </b-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
      size: {
        type: String,
        default: 'md',
      },
    },
    data() {
      return {
        trans: trans,
        answer: null,
        error: null,
      }
    },
    computed: {
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
      hasDescriptions() {
        if (!this.block) return false
        return _.reduce(this.block.meta.options || [], (has, o) => {
          if (!!o.description) has = true
          return has
        }, false)
      },
      correctAnswer() {
        if (!this.block) return null
        return this.block.meta.correct_answer || undefined
      },
      correctAnswerDescription() {
        if (!this.block) return null
        return this.block.meta.correct_answer_description || null
      },
      inline() {
        if (!this.block) return false
        return this.block.meta.inline && !this.hasDescriptions
      },
      options() {
        if (!this.block) return []
        return this.block.meta.options
      },
    },
    methods: {
      onClear() {
        this.answer = null
      },
    },
  }
</script>